import { render, staticRenderFns } from "./OrganismHighlightSpace.vue?vue&type=template&id=8991b84c&scoped=true&"
import script from "./OrganismHighlightSpace.vue?vue&type=script&lang=js&"
export * from "./OrganismHighlightSpace.vue?vue&type=script&lang=js&"
import style0 from "./OrganismHighlightSpace.vue?vue&type=style&index=0&id=8991b84c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8991b84c",
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismHighlightSpace.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Forganisms%2Fproject%2FOrganismHighlightSpace.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectMoleculeContractDetailsContainer: require('/app/components/molecules/project/MoleculeContractDetailsContainer.vue').default})
